/* 문화포럼 일정 등록 페이지 */import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import {constance} from '../../common/constance/constance';
import Stack from '@mui/material/Stack';
import {config} from '../../common/config/config';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {styles} from '../../common/style';
import {Button, MenuItem, MenuList, Paper, Tooltip} from '@mui/material';
import {common} from '../../common/common';
import ImageUploading from 'react-images-uploading';
import {useNavigate} from 'react-router-dom';
import {User} from '../../interface/user.interface';
import {Book} from "../../interface/book.interface";
import WorkplaceComponent from "./WorkplaceComponent";

interface State {
    bookList: Book[];
}

function BookRegister() {
    const [bookList, setBookList] = useState<Book[]>([]);

    const bookNameRef: any = useRef();
    const bookAuthorRef: any = useRef();
    const bookPublisherRef: any = useRef();
    const workplaceRef: any = useRef();

    useEffect(() => {
        getBookList();
    }, []);

    function getBookList() {
        /* 사용자 리스트 가지고 오기 */
        axios.get(constance.api.getBookList, {
            params: {
                isAdmin: 'Y',
            }
        }).then((value) => {
            console.log(value.data.bookList);
            setBookList(value.data.bookList);
        }).catch(reason => {
        });
    }

    function handleSave() {
        let bookName: string = bookNameRef.current.value;
        let bookAuthor: string = bookAuthorRef.current.value;
        let bookPublisher: string = bookPublisherRef.current.value;
        let workplace: string = workplaceRef.current.value;

        axios.post(constance.api.saveBook, {
            params: {
                name: bookName,
                author: bookAuthor,
                publisher: bookPublisher,
                workplace: workplace,
            },
        }).then(value => {
            if (value.data.result) {
                common.alert('도서 생성 완료', '', 'info');
            } else {
                common.alert('도서 생성 실패', '이미 존재하는 도서 입니다.', 'info');
            }
            bookNameRef.current.value = '';
            bookAuthorRef.current.value = '';
            bookPublisherRef.current.value = '';
            getBookList();
        })
    }

    function handleDelete(book: Book) {
        let callback = (params: { book: Book }) => {
            return axios.post(constance.api.deleteBook, {
                params: {
                    _id: params.book._id,
                },
            }).then(value => {
                if (value.data.result) {
                    common.alert('도서 삭제 완료', '', 'info');
                } else {
                    common.alert('도서 삭제 실패', '', 'info');
                }
                bookNameRef.current.value = '';
                bookAuthorRef.current.value = '';
                bookPublisherRef.current.value = '';
                getBookList();
            })
        }
        common.confirm(
            `${book.name} 도서를 삭제하시겠습니까?`,
            `도서를 삭제하면 도서 게시판에서 해당 도서의 게시글은 조회되지 않습니다. 
            도서명을 변경해야 할 경우 IT팀 관리자에게 요청하여 주세요.`,
            'warning',
            callback,
            {book: book}
        );
    }

    return (
        <>
            <Stack sx={{width: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Box id="box"
                     sx={{
                         display: 'flex',
                         pt: 3,
                         maxWidth: config.maxWidth,
                         width: 1,
                         justifyContent: 'center',
                         alignItems: 'flex-start'
                     }}>
                    <Stack sx={{width: 0.7, height: 1, mr: 3}}>
                        <Paper sx={{width: 1, p: 2}}>
                            <Stack>
                                <Box sx={{width: 1, display: 'flex', mb: 1, borderBottom: styles.border, pb: 1}}>
                                    <Typography align={"center"} sx={{width: 0.1}}>{'사업장'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.25}}>{'도서명'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.25}}>{'저자'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.15}}>{'출판사'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.15}}>{'등록일'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.1}}>{''}</Typography>
                                </Box>
                                {
                                    bookList.map((value, index) => {
                                        return (
                                            <Box key={index}
                                                 sx={{width: 1, display: 'flex', alignItems: 'center', pt: 0.5, pb: 0.5, borderBottom: styles.border}}>
                                                <Typography align={"center"}
                                                            sx={{width: 0.1, pl: 0.5, pr: 0.5}}>
                                                    {constance.workplaceNameMap[value.workplace]}
                                                </Typography>

                                                <Tooltip title={value.name}>
                                                    <Typography align={"center"} sx={{width: 0.25, pl: 0.5, pr: 0.5, ...styles.textHidden}}>{value.name}</Typography>
                                                </Tooltip>
                                                <Tooltip title={value.author}>
                                                    <Typography align={"center"} sx={{width: 0.25, pl: 0.5, pr: 0.5, ...styles.textHidden}}>{value.author}</Typography>
                                                </Tooltip>

                                                <Typography align={"center"} sx={{width: 0.15, pl: 0.5, pr: 0.5}}>{value.publisher}</Typography>

                                                <Typography align={"center"} sx={{width: 0.15, pl: 0.5, pr: 0.5}}>{common.getTimeFormatYMD(value.createdAt)}</Typography>

                                                <Button sx={{width: 0.1}}
                                                        size={"small"}
                                                        color={"error"}
                                                        onClick={() => handleDelete(value)}
                                                        variant={"contained"}>
                                                    <Typography>삭제</Typography>
                                                </Button>
                                            </Box>
                                        )
                                    })
                                }
                            </Stack>
                        </Paper>
                    </Stack>
                    <Stack sx={{
                        width: 0.3,
                        maxWidth: config.maxWidth,
                        alignItems: 'center',
                    }}>

                        {/* 사업장 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            borderBottom: '0px',
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'사업장'}</Typography>
                            </Box>
                            <Stack
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <WorkplaceComponent workplaceRef={workplaceRef} useAllWorkplace={'N'}/>
                            </Stack>
                        </Box>

                        {/* 도서명 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'도서명'}</Typography>
                            </Box>
                            <Box sx={{
                                flexGrow: 1,
                                backgroundColor: styles.backgroundColor.contentBox,
                                p: 1,
                            }}>
                                <TextField inputRef={bookNameRef}
                                           defaultValue={''}
                                           type={'text'}
                                           label="" variant="outlined"
                                           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                                />
                            </Box>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            borderTop: '0px',
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'저자'}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <TextField inputRef={bookAuthorRef}
                                           defaultValue={''}
                                           type={'text'}
                                           label="" variant="outlined"
                                           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                                />
                            </Box>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            borderTop: '0px',
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'출판'}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <TextField inputRef={bookPublisherRef}
                                           defaultValue={''}
                                           type={'text'}
                                           label="" variant="outlined"
                                           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                                />
                            </Box>
                        </Box>


                        <Box sx={{mt: 2}}>
                            <Button onClick={handleSave}
                                    variant={'contained'}>
                                <Typography> {'등록'}</Typography>
                            </Button>
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
};

export default BookRegister;